interface UseHashEmailReturn {
  hashEmail: (email: any) => Promise<[string | null, string | null]>;
}

const useMD5HashEmail = (): UseHashEmailReturn => {
  const hashEmail = async (email: any): Promise<[string | null, string | null]> => {
    try {
      const response = await fetch('/api/hash-email/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error('Failed to hash the email');
      }

      const data = await response.json();
      const { hashedEmail } = data;

      return hashedEmail;
    } catch (err) {
      return ['Error hashing email', null];
    }
  };

  return { hashEmail };
};

export default useMD5HashEmail;
